import {
    Howl,
} from 'howler';
import store from '@/store/'
import axios from 'axios';
import md5 from 'blueimp-md5'
import $ from 'jquery'
import wx from 'weixin-js-sdk'
import * as PIXI from 'pixi.js'
if (process.env.NODE_ENV == "development") {
    window.PIXI = PIXI;
    window.$ = $;
}
function isWeiXinfn() {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return 1;
    } else {
        return 0;
    }
}
export function RandomNumBoth(Min, Max) {
    var Range = Max - Min;
    var Rand = Math.random();
    var num = Min + Math.round(Rand * Range); //四舍五入
    return num;
}

function ismobilefn() {
    var ua = navigator.userAgent;
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid;
    //判断
    if (isMobile) {
        return 1;
    } else {
        return 0;
    }
}

function getdevicetype() {
    var u = navigator.userAgent,
        app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        return 'android';
    }
    if (isIOS) {
        return 'ios';
    }
}
export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
}
export function addParam(url, paramKey, paramVal) {
    var andStr = "?";
    var beforeparam = url.indexOf("?");
    if (beforeparam != -1) {
        andStr = "&";
    }
    return url + andStr + paramKey + "=" + encodeURIComponent(paramVal);
}
export function GetRequest() {
    var url = location.search; //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}
export function setCookie(name, value) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}
function shiyingkuandu() {
    /*针对PC全屏触发*/
    if (bodyWidth >= bodyHeight && ismobile == 0) {
        document.getElementsByTagName("body")[0].style.width = (bodyHeight * 0.6) + "px";
        document.getElementsByTagName("body")[0].style.margin = "0 auto";
    }
}
export function getrem() {
    shiyingkuandu();
    var clientWidth = parseInt(document.body.clientWidth);
    if (!clientWidth) return;
    document.getElementsByTagName("html")[0].style.fontSize = 20 * (clientWidth / 320) + 'px';
    /*部分安卓手机计算rem有误差 如果有误差 需要重新设置font-size 从而计算出正确的值*/
    var div = document.createElement('div');
    div.style.width = '1.4rem';
    div.style.height = '0';
    document.body.appendChild(div);
    var ideal = 1.4 * 20 * (clientWidth / 320);
    var rem = div.clientWidth;
    var scale = rem / ideal;
    /*因为css获取属性值只保留整数 */
    if (scale > 1.05 || scale < 0.95) {
        document.getElementsByTagName("html")[0].style.fontSize = 20 * (clientWidth / 320) + 'px';
        document.body.removeChild(div);
    }
}
export function iswebasmfn() {
    var useWasm = 0;
    var webAsmObj = window["WebAssembly"];
    if (typeof webAsmObj === "object") {
        if (typeof webAsmObj["Memory"] === "function") {
            if ((typeof webAsmObj["instantiateStreaming"] === "function") || (typeof webAsmObj["instantiate"] === "function")) useWasm = 1;
        }
    }
    return useWasm;
}
export function iskong(name) {
    if (typeof (name) == "undefined" || name == '' || name == null) {
        return true;
    } else {
        return false;
    }
}
export function isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if (regPos.test(val) || regNeg.test(val)) {
        return true;
    } else {
        return false;
    }
}

function touchstartfn() {
    if (ismobile) {
        START_EV = 'touchstart';
    } else {
        START_EV = 'click';
    }
    return START_EV;
}

function touchmovefn() {
    if (ismobile) {
        MOVE_EV = 'touchmove';
    } else {
        MOVE_EV = 'mousemove';
    }
    return MOVE_EV;
}

function touchendfn() {
    if (ismobile) {
        END_EV = 'touchend';
    } else {
        END_EV = 'mouseup';
    }
    return END_EV;
}

function isshowdibudaohang() {
    var pingmubilv = (bodyHeight / bodyWidth).toFixed(2);
    var iswebasm = iswebasmfn();
    var object = {};
    object['clientwidth'] = bodyWidth;
    object['clientheight'] = bodyHeight;
    object['pingmubilv'] = pingmubilv;
    object['iswebasm'] = iswebasm;
    netpost('/' + kongzhiqi + '/updateclient', object).then(function (data) {

        if (data.code == 100) {
            let list = data.data.userinfo;
            let nickname = list.nickName;
            let avatar = list.avatar;
            setTimeout(() => {
                if (!iskong(nickname)) {
                    store.commit("nicknameset", nickname);
                    store.commit("avatarset", avatar);
                }

            }, 300)

        } else {
            tanc(data.msg);
        }
    })
    if (devicetype == "android") {
        fanhuishezhi();


    }
}
// vue 安卓后退见不到 应该冲突了

function fanhuishezhi() {

    if (window.history && window.history.pushState) {

    }
}
var sound;
var clickyinxiao;
var yinpin;
export function jiazaimusicfn() {
    if (window.isrunfirst == 1) {
        if (isweixin) {
            // ajaxshareinit();
            ajaxshareinit1();
        }
    }
    // 页面跳转的时候 就直接加载了
    if (window.isrunfirst == 0) {
        store.commit('yujiazaiset', 1);
        store.commit('jinduset', 30);
        yujiazai();


        return false;
    }



    bodyWidth = document.body.clientWidth;
    bodyHeight = document.body.clientHeight
    // 注意加载页面还是不要用rem了 直接px写死就可以了 整体位置可以用下百分比控制
    // 这里还是等页面加载完 再来控制getrem 
    getrem();






    netpost('/' + kongzhiqi + '/getShareinfoAjax', {}).then(function (data) {

        if (data.code == 100) {
            var list = data.data;
            var title = list.info.TITLE;
            $('title').text(title);
        }
    })



    /*针对PC全屏触发*/
    if (bodyWidth >= bodyHeight && ismobile == 0) {
        document.getElementsByTagName("body")[0].style.width = (bodyHeight * 0.6) + "px";
        document.getElementsByTagName("body")[0].style.margin = "0 auto";
    }
    if (!iskong(document.getElementById('bgmusic'))) {
        jiazaidingshiqi();
        var musicsrc = document.getElementById('bgmusic').getAttribute('musicsrc');
        sound = new Howl({
            src: [musicsrc],
            loop: true,
            onload: function () {
                store.commit('jinduset', 30);
                clearInterval(jiazaimusctimer);
                beginjiazai();
            },
            onloaderror: function () {
                var object = {};
                /*用异步 防止显示图片堵塞 */
                netpost('/common/recordmp3error', object)
                tanc('音乐加载失败', function () {
                    reloadpage();
                });
            }
        });
        clickyinxiao = new Howl({
            src: ['https://oss.zhihuxuetang.cn/uploadpic/xiangmu/lanchengyuandan/music/dianji.mp3']
        });
        yinpin = new Howl({
            src: ['https://oss.zhihuxuetang.cn/lanchenghongbao/music/yinpin.mp3']
        });
    } else {
        beginjiazai();
    }
}

function beginjiazai() {
    isshowdibudaohang();
    mobilerotate();
    window.onresize = function () {

        getrem();
    };
    yujiazai();
}
export function tanc(text, fn) {
    $('[vartype="chuangtitle"]').html(text);
    $('.morentanchuang').fadeIn();
    $('.chuangbtn').unbind();
    $('.chuangbtn').on(START_EV, function () {
        if (iskong(fn)) {
            $('.morentanchuang').css('display', 'none');
        } else {
            $('.morentanchuang').css('display', 'none');
            fn();
        }
        return false;
    })
}
/*没带参数的用这个*/
export function reloadpage() {
    window.location.reload(true);
}

export function reloadpageindex() {
    let url = window.location.href;
    let url0 = url.split("?play_id")[0];
    window.location.href = url0 + '#/';
}
Number.prototype.toFixed = function (d) {
    var s = this + "";
    if (!d) d = 0;
    if (s.indexOf(".") == -1) s += ".";
    s += new Array(d + 1).join("0");
    if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
        var s = "0" + RegExp.$2,
            pm = RegExp.$1,
            a = RegExp.$3.length,
            b = true;
        if (a == d + 2) {
            a = s.match(/\d/g);
            if (parseInt(a[a.length - 1]) > 4) {
                for (var i = a.length - 2; i >= 0; i--) {
                    a[i] = parseInt(a[i]) + 1;
                    if (a[i] == 10) {
                        a[i] = 0;
                        b = i != 1;
                    } else break;
                }
            }
            s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");
        }
        if (b) s = s.substr(1);
        return (pm + s).replace(/\.$/, "");
    }
    return this + "";
};
String.prototype.trim = function (char, type) {
    if (char) {
        if (type == 'left') {
            return this.replace(new RegExp('^\\' + char + '+', 'g'), '');
        } else if (type == 'right') {
            return this.replace(new RegExp('\\' + char + '+$', 'g'), '');
        }
        return this.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '');
    }
    return this.replace(/^\s+|\s+$/g, '');
};

function delParam1(url, paramKey) {
    var urlParam = url.substr(url.indexOf("?") + 1);
    var beforeUrl = url.substr(0, url.indexOf("?"));
    var nextUrl = "";
    var arr = new Array();
    if (urlParam != "") {
        var urlParamArr = urlParam.split("&");
        for (var i = 0; i < urlParamArr.length; i++) {
            var paramArr = urlParamArr[i].split("=");
            if (paramArr[0] != paramKey) {
                arr.push(urlParamArr[i]);
            }
        }
    }
    url = beforeUrl + nextUrl;
    return url;
}

function mobilerotate() {
    if (ismobile == 1) {
        /*只会关闭的竖屏锁定才会触发*/
        window.addEventListener("orientationchange", function () {
            setTimeout(function () {
                if (bodyWidth >= bodyHeight) {
                    store.commit('suodingtipset', 'display:block');
                } else {
                    /*竖屏*/
                    store.commit('suodingtipset', 'display:none');
                }
            }, 200)
        });
    }
}
window.iszhixinginitrequest = 0;
export function initrequest() {
    if (window.iszhixinginitrequest == 1) {
        return false;
    }
    if (process.env.NODE_ENV === "development") {
        // axios.defaults.baseURL = 'http://wxserver.zhihuxuetang.cn:8789/';
        // axios.defaults.baseURL = 'http://wxserver.zhihuxuetang.cn:8789/';
        axios.defaults.baseURL = 'http://webmanbendi.zhihuxuetang.cn/';
    } else {
        axios.defaults.baseURL = 'https://webman.zhihuxuetang.cn/';
    }
    axios.defaults.timeout = 10000;


    // request拦截器
    axios.interceptors.request.use(config => {
        if (config.method === 'post') {

            config.data['openid'] = openid;
            config.data['suijishu'] = Math.ceil(Math.random() * 1000);
            config.data['session_key'] = session_key;
            config.data['signver'] = 2;
            var haomiaotime = Date.parse(new Date()).toString(); //获取到毫秒的时间戳，精确到毫秒
            //这里毫秒 我当随机数和时间了
            config.data['haomiaotime'] = haomiaotime;
            //上面 object 这个是要传的参数
            var ss = '';
            for (var k in config.data) {
                if (!iskong(config.data)) {
                    // 图片参与去掉 就不用参与签名验证了
                    if (k != 'pic') {
                        ss += '&' + k + '=' + encodeURIComponent(config.data[k]);
                    }
                }

            }
            var sign = md5(encodeURIComponent(ss));

            config.data['sign'] = sign;

        };
        return config
    }, error => {
        // Do something with request error
        console.log(error) // for debug
        tanc('发送请求失败,请刷新重试' + error)
    })
    axios.interceptors.response.use(data => {
        var list = data.data;
        var code = parseInt(list.code);
        if (code != 100) {
            if (code == 299) {
                store.commit('sharetipcontainerset', 1);
            } else if (code == 434) {

            } else if (code == 987) {

            } else if (code == 2132) {

            } else {
                store.commit('isshowjiazaiset', 0);
                tanc(list.msg);
            }

        }

        return data;
        // return data;
    }, error => {
        console.log(error) // for debug
        tanc('网络连接超时,请保证当前网络流畅,刷新重试')
    })
    window.iszhixinginitrequest = 1;

}
export function getopenid() {

    // 先获取当前域名是不是wxserver.zhihuxuetang.cn
    var curhref = window.location.host;
    if (process.env.NODE_ENV != "development") {
        if (curhref.indexOf("wxserver.zhihuxuetang.cn") == -1) {
            alert('当前链接错误');
            return false;
        }
    }

    var kongzhiqiD = kongzhiqi.toUpperCase();
    if (process.env.NODE_ENV === "development") {
        openid = 'oKO5psxBkYTp18F9z-U9vZCfsNKI';
        setCookie('OAUTH_' + kongzhiqiD, openid);

        return openid;
    } else {
        // 授权登陆以后传回openid 那就放到cookie  否则就不要放

        var openid1 = getCookie('OAUTH_' + kongzhiqiD);

        if (openid1 == null) {
            // 如果有后缀名自己加
            var url = window.location.href;
            console.log("url:", url);

            // 因为授权登录地址不能包含# 所以要去掉

            let url0 = url.split("#/")[0];
            let url1 = url.split("#/")[1];
            if (iskong(url1)) {
                url1 = '';
            }
            let state = kongzhiqi + '@@' + url1;

            url0 = encodeURI(url0);





            var redirecturl = 'https://wxserver.zhihuxuetang.cn/codenew7.php?url=' + url0;
            redirecturl = encodeURI(redirecturl);
            let tzurl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirecturl + '&response_type=code&scope=snsapi_userinfo&state=' + state + '&connect_redirect=1#wechat_redirect';
            console.log(tzurl);
            window.location.href = tzurl;
            return false;
        } else {
            openid = openid1
        }
    }

}

export function getsessionkey(next) {

    var kongzhiqiD = kongzhiqi.toUpperCase();
    if (process.env.NODE_ENV === "development") {
        session_key = '2286b3181af5ab1f776815873d306141';
        setCookie('SESSIONKEY_' + kongzhiqiD, session_key);
        initrequest();

        // 这里可以判断 写入口
        netpost('/' + kongzhiqi + '/recordipdiqu', {}).then(function (data) {

            if (data.code == 100) {

                next();



            } else {
                alert(data.msg);
            }
        });
    } else {


        var session_key1 = getCookie('SESSIONKEY_' + kongzhiqiD);
        if (session_key1 == null) {
            var url = window.location.href;
            console.log("url:", url);

            // 因为授权登录地址不能包含# 所以要去掉

            let url0 = url.split("#/")[0];
            let url1 = url.split("#/")[1];
            if (iskong(url1)) {
                url1 = '';
            }
            let state = kongzhiqi + '@@' + url1;

            url0 = encodeURI(url0);


            var redirecturl = 'https://wxserver.zhihuxuetang.cn/codenew7.php?url=' + url0;
            redirecturl = encodeURI(redirecturl);
            let tzurl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirecturl + '&response_type=code&scope=snsapi_userinfo&state=' + state + '&connect_redirect=1#wechat_redirect';

            window.location.href = tzurl;
            return false;
        } else {
            session_key = session_key1
            initrequest();
            // 这里可以判断 写入口
            netpost('/' + kongzhiqi + '/recordipdiqu', {}).then(function (data) {

                if (data.code == 100) {

                    next();



                } else {
                    alert(data.msg);
                }
            });
        }
    }
}
var jiazaimusctimer;
export function jiazaidingshiqi() {
    store.commit('yujiazaiset', 1);
    store.commit('jinduset', 0);
    clearInterval(jiazaimusctimer);
    var iii = 1;
    jiazaimusctimer = setInterval(function () {
        iii++;
        if (iii >= 30) {
            iii = 30;
        }
        store.commit('jinduset', iii);
    }, 1000)
}

function yujiazai() {


    /*这个是用在没有预加载的情况下的*/
    var loadimglength = parseInt(document.getElementsByClassName('loadimg').length);
    if (loadimglength == 0) {
        jiazaisuccess();
    }
    var load_img = [];
    for (var i = 0; i < loadimglength; i++) {
        var loadimg = document.getElementsByClassName('loadimg')[i].getAttribute('loadimg');

        if (typeof (loadimg) == "undefined" || loadimg == '' || loadimg == null) {

            console.log("loadimg", document.getElementsByClassName('loadimg')[i]);
            return false;
            tanc('加载错误,详情看控制台');
            return false;
        }
        //没重复的添加进去
        var index = load_img.indexOf(loadimg);
        if (index == -1) {
            load_img.push(loadimg);
        }
    }
    var lastimglength = load_img.length;
    var isload = 0;

    load_img.forEach((item, index) => {

        const image = new Image()
        image.src = item
        image.onload = () => {
            isload++;
            var progressre = parseInt(isload * 70 / lastimglength) + 30;
            // 加载完一张就显示一张
            Vue.nextTick()
                .then(function () {
                    // DOM 更新了
                    $('.loadimg[loadimg="' + item + '"]').attr('src', item);
                    // 有时候会跟vue异步渲染冲突 所以赋值完还要检测一下有没有成功赋值 
                    let src = $('.loadimg[loadimg="' + item + '"]').attr('src');
                    if (iskong(src)) {
                        setTimeout(() => {
                            $('.loadimg[loadimg="' + item + '"]').attr('src', item);
                        }, 200);
                    }
                })

            console.log("loadimg", progressre);
            if (progressre <= 30) {
                progressre = 30;
            } else if (progressre >= 100) {
                progressre = 100;
            }
            store.commit('jinduset', progressre);
            if (isload === (load_img.length)) {
                setTimeout(() => {
                    jiazaisuccess();
                }, 100)

            }
        }
        image.onerror = () => {
            console.log('加载失败' + item);
            tanc('加载失败');
            var errofile = item;
            var object = {};
            object['errofile'] = errofile;
            netpost('/common/jiazaishibai/', object);
        }
    })
}
var pixiimglist = {};
function jiazaipic2() {
    // 加载pixijs 一些东西
    $('.pixiimg').each(function () {
        let src = $(this).attr('src');
        let imgkey = $(this).attr('imgkey');
        console.log("imgkey", imgkey);
        console.log("src", src);
        let texture = PIXI.Texture.from(src);
        pixiimglist[imgkey] = texture;
    })

    /*这个是用在没有预加载的情况下的*/
    var loadimglength = parseInt(document.getElementsByClassName('loadimg1').length);
    var load_img = [];
    for (var i = 0; i < loadimglength; i++) {
        var loadimg = document.getElementsByClassName('loadimg1')[i].getAttribute('loadimg1');
        if (typeof (loadimg) == "undefined" || loadimg == '' || loadimg == null) {
            tanc('加载错误,详情看控制台');
        }
        //没重复的添加进去
        var index = load_img.indexOf(loadimg);
        if (index == -1) {
            load_img.push(loadimg);
        }
    }
    console.log("load_img1", load_img);
    load_img.forEach((item, index) => {

        const image = new Image()
        image.src = item
        image.onload = () => {
            Vue.nextTick()
                .then(function () {
                    $('.loadimg1[loadimg1="' + item + '"]').attr('src', item);
                    var src = $('.loadimg1[loadimg1="' + item + '"]').attr('src');
                    if (iskong(src)) {
                        // 有时候会跟vue异步渲染冲突 所以这里再来一次
                        setTimeout(() => {
                            $('.loadimg1[loadimg1="' + item + '"]').attr('src', item);
                        }, 200);
                    }
                    console.log("加载完成loadimg1", item);
                })

        }
        image.onerror = () => {
            console.log('加载失败' + item);
            var errofile = item;
            var object = {};
            object['errofile'] = errofile;
            netpost('/common/jiazaishibai/', object);
        }
    })
}

function suodingpanduan() {
    if (ismobile == 1) {
        var bodywidth = $('body').width();
        var bodyheight = $('body').height();
        if (bodywidth >= bodyheight) {
            store.commit('suodingtipset', 'display:block');
        } else {
            store.commit('suodingtipset', 'display:none');
        }
    }
}
export function commonswiper(swiper, swipercontainerclass) {

    //  判断有没有加载完成 如果没有加载完成出现进度条
    var ishasjinzhi = $(swipercontainerclass + ' .swiper-slide-active').hasClass('swiper-no-swiping');
    if (ishasjinzhi) {
        store.commit('starset', 'display:none');
    } else {

        if (swiper.isEnd) {
            store.commit('starset', 'display:none');

        } else {
            store.commit('starset', 'display:block');
        }

    }

}

export function pagegundong(objp, isauto = 0) {

    /*所有所有预置动画的img */
    var alltreeaniimg = $(objp).find('.vhidden');
    var alltreeaniimglen = alltreeaniimg.length;
    if (alltreeaniimglen == 0) {
        return false;
    }
    var arr = [];
    var fontsize = parseFloat($('html').css('font-size'));
    var bodyheight = parseInt($('body').css('height'));
    for (let i = 0; i < alltreeaniimglen; i++) {
        let treeimgtop = $(alltreeaniimg[i]).offset().top;
        treeimgtop = ((treeimgtop) / fontsize).toFixed(2);
        arr.push(treeimgtop);
    }

    if (objp.find('.bgc').length == 0) {
        tanc('确少class:"bgc"')
        return false;
    }
    var p2_bgheight = parseInt(objp.find('.bgc').css('height'));
    var zhongdian = p2_bgheight - bodyheight;
    console.log(zhongdian);
    // $('.p2').animate({scrollTop: zhongdian}, 3000,'linear');
    //    $('.p2').stop();
    //    
    //    
    var p1scrolltop = $(objp).scrollTop();
    var remshuzi = p1scrolltop / fontsize;
    /*所有滚动不能超过这个最大的*/
    var zuidazhiremshuzi = zhongdian / fontsize;
    remshuzi = remshuzi.toFixed(2);
    for (var i = 0; i < arr.length; i++) {
        var gaodu = arr[i];
        /*一开始 屏幕上能看到的都显示   */
        var bodyheightrem = parseFloat((bodyheight / fontsize).toFixed(2));
        if (isauto == 1) {
            bodyheightrem = 99999;
        }
        if (gaodu <= bodyheightrem) {
            let obj = $(objp).find('.vhidden').eq(i);
            let animindex = parseInt(obj.attr('animindex'));
            store.commit('longanimattrset', animindex);

        }
    }
    var isdaoda = 0;
    $(objp).scroll(function () {
        console.log(111111);
        var p1scrolltop = $(objp).scrollTop();
        var remshuzi = p1scrolltop / fontsize;
        /*所有滚动不能超过这个最大的*/
        var zuidazhiremshuzi = zhongdian / fontsize;
        console.log(zuidazhiremshuzi);

        remshuzi = remshuzi.toFixed(2);
        if (remshuzi >= zuidazhiremshuzi - 0.3) {
            if (isdaoda == 1) {
                return false;
            }
            isdaoda = 1;
            console.log('滑到终点了');
        }
        console.log("rem数字=" + remshuzi);
        for (var i = 0; i < arr.length; i++) {
            var gaodu = arr[i];
            if ((remshuzi - (gaodu - bodyheightrem)) > 4) {
                let obj = $(objp).find('.vhidden').eq(i);
                let animindex = parseInt(obj.attr('animindex'));
                store.commit('longanimattrset', animindex);
            }
        }
    })
}



// 这个用于页面跳转的 防止重复加载逻辑
window.isrunfirst = 1;
function jiazaisuccess() {
    //   分享加载音乐运行过了就不需要再运行了
    if (window.isrunfirst == 1) {
        if (isweixin) {
            // ajaxshareinit();
            wx.ready(function () {
                wx.hideOptionMenu();
                if (!iskong(document.getElementById('bgmusic'))) {
                    playbgmusic();
                }

            });
        }
    }
    window.isrunfirst = 0;
    jiazaipic2();

    if (devicetype == "android") {
        ruanjianpan();
        ruanjianpan1();
    } else if (devicetype == "ios") {
        ruanjianpan2();
    }



    setTimeout(function () {
        window.initPage();

        store.commit('yujiazaiset', 0);
    }, 500)

    suodingpanduan();
}

export var ntitle;
export var ndesc;
export var nimgUrl;
export var nlink;
function ajaxshareinit1() {
    var url = location.href.split('#')[0];
    var object = {};
    object['url'] = url;
    netpost('/' + kongzhiqi + '/getjssdkinfo', object).then(function (data) {
        var list = data.data;
        var jsapiSignature = list.jsapiSignature;
        var appId = jsapiSignature['appId'];
        var timestamp = jsapiSignature['timestamp'];
        var nonceStr = jsapiSignature['nonceStr'];
        var signature = jsapiSignature['signature'];
        ntitle = jsapiSignature['title'];
        ndesc = jsapiSignature['desc'];
        var jsapi_ticket = jsapiSignature['jsapi_ticket'];
        nimgUrl = jsapiSignature['imgUrl'];
        nlink = jsapiSignature['link'];
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature, // 必填，签名，见附录1
            jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'translateVoice', 'startRecord', 'stopRecord', 'onRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'openLocation', 'getLocation', 'hideOptionMenu', 'showOptionMenu', 'closeWindow', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard']
        });
        console.log("appId:" + appId);
        console.log("jsapi_ticket:" + jsapi_ticket);
        console.log("timestamp:" + timestamp);
        console.log("nonceStr:" + nonceStr);
        console.log("signature:" + signature);
        console.log("url:" + url);
        wx.ready(function () {
            wx.hideOptionMenu();
            wx.checkJsApi({
                jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'],
                success: function (res) {
                    //alert(JSON.stringify(res));
                }
            });
            wx.hideMenuItems({
                menuList: ['menuItem:copyUrl'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
            });
            commonshare(ntitle, ndesc, nimgUrl, nlink);
        });
    });
}

export function playbgmusic() {

    sound.play();
    store.commit('isplaybgmusicset', 1);
}
export function stopbgmusic() {

    sound.pause();
    store.commit('isplaybgmusicset', 0);
}
window.testshare = () => {
    commonshareluoji(1);
}
function commonshareluoji(ispyq) {


    var object = {};
    object['ispyq'] = ispyq;
    netpost('/' + kongzhiqi + '/shareinfo', object).then(function (data) {

        if (data.code == 100) {
            var list = data.data;
        } else {
            tanc(data.msg);
        }
    });
}

export function commonshare(ntitle, ndesc, nlogo, link) {
    wx.onMenuShareAppMessage({
        title: ntitle,
        desc: ndesc,
        link: link,
        imgUrl: nlogo,
        success: function (res) {
            var ispyq = 0;
            commonshareluoji(ispyq);
        }
    });
    wx.onMenuShareTimeline({
        title: ntitle,
        desc: ndesc,
        link: link,
        imgUrl: nlogo,
        success: function (res) {
            var ispyq = 1;
            commonshareluoji(ispyq);
        }
    });
}

function jiazaipiclist(load_img, fn) {
    load_img.forEach((item, index) => {
        console.log(index)
        const image = new Image()
        image.src = item
        image.onload = () => {
            if (index === (load_img.length - 1)) {
                fn();
            }
        }
        image.onerror = () => {
            tanc('加载失败' + item);
        }
    })
}
/*ios专用*/
// ios端$('body').scrollTop()会改变
// android端$(window).height()会改变
function ruanjianpan2() {
    $('input,textarea,select').on('blur', function () {
        setTimeout(function () {
            //判断是不是继续点击第二个input继续 如果是 那不用 页面往下移 页面不会往上弹了
            var isfocus = $("input,textarea,select").is(":focus");
            if (isfocus != 1) {
                //输入完以后页面整体会往上移
                $('body').scrollTop(0);
            }
        }, 200)
    });
}


/*根目录用class pruanjianpan*/
function ruanjianpan1() {
    var bodyheight = $('body').height();
    var bodywidth = $('body').width();
    var iscanblur = 0;
    $('.pruanjianpan input[type=text], .pruanjianpan input[type=tel],  .pruanjianpan input[type=number], .pruanjianpan textarea').on('click', function () {
        iscanblur = 1;
        store.commit('suodingtipset', 'display:none');
        var inputwarptop = $(this).offset().top;
        $('.pruanjianpan').find('.bg').css('height', bodyheight);
        $('.pruanjianpan').find('.bg').css('width', bodywidth);
        $('.pruanjianpan').css('height', bodyheight);
        $('.pruanjianpan').css('width', bodywidth);
        $('.pruanjianpan').css('top', '-' + (inputwarptop - 100) + 'px');
        //点击空余地方关闭键盘 没办法判断及是不是input
        // $(this).blur(function() {
        //     if (iscanblur == 1) {
        //         /*保证触发一次*/
        //         iscanblur = 0;
        //         /*这里改*/
        //         // alert("触发了点击空余地方关闭键盘")
        //         $('.pruanjianpan').css('top', '0px');
        //         document.body.scrollTop = 0;
        //         clearInterval(aa);
        //     }
        // })
        //判断是否关闭键盘
        setTimeout(function () {
            var aa = setInterval(function () {
                var actbodyheight = $('body').height();
                if (bodyheight == actbodyheight) {
                    $('.pruanjianpan').css('top', '0px');
                    document.body.scrollTop = 0;
                    clearInterval(aa);
                }
            }, 200)
        }, 1000)
    })
}
/*silde默认专属     苹果软键盘会挤上去 安卓不会*/
function ruanjianpan() {
    var aa;
    var bodyheight = $('body').height();
    var bodywidth = $('body').width();
    /*这里改*/
    var iscanblur = 0;
    $('.swiper-container input[type=text], .swiper-container input[type=tel],  .swiper-container input[type=number], .swiper-container textarea').on('click', function () {
        iscanblur = 1;
        store.commit('suodingtipset', 'display:none');
        var inputwarptop = parseInt($(this).offset().top) + Math.abs(parseInt($('.swiper-container').css('top')));
        /*这里改*/
        $('.swiper-container .bg').css('height', bodyheight);
        $('.swiper-container .bg').css('width', bodywidth);
        $('.swiper-container').css('height', bodyheight);
        $('.swiper-container').css('width', bodywidth);
        $('.swiper-container').css('top', '-' + (inputwarptop - 100) + 'px');
        $('.swiper-slide').css('height', bodyheight);
        $('.swiper-slide').css('width', bodywidth);
        //点击空余地方关闭键盘 没办法判断是否点击的是input
        // $(this).blur(function() {
        //     if (iscanblur == 1) {
        //         /*保证触发一次*/
        //         iscanblur = 0;
        //         /*这里改*/
        //         // alert("触发了点击空余地方关闭键盘")
        //         $('.swiper-container').css('top', '0px');
        //         document.body.scrollTop = 0;
        //         clearInterval(aa);
        //     }
        // })
        /*关闭软键盘*/
        setTimeout(function () {
            // alert("bodyheight:"+bodyheight);
            // alert("actbodyheight:"+actbodyheight);            
            aa = setInterval(function () {
                var actbodyheight = $('body').height();
                if (bodyheight == actbodyheight) {
                    /*这里改*/
                    // alert("触发了关闭软键盘触发了键盘")
                    $('.swiper-container').css('top', '0px');
                    document.body.scrollTop = 0;
                    clearInterval(aa);
                }
            }, 50)
        }, 1000)
    })
}

function getresourcepath() {

    if (process.env.NODE_ENV === "development") {
        var resourcepath = '/static';
    } else {
        var resourcepath = 'https://oss.zhihuxuetang.cn/' + kongzhiqi;



    }
    return resourcepath;
}
export var bodyWidth;
bodyWidth = document.body.clientWidth;


export var bodyHeight;
export var kongzhiqi = 'dahuaduanwu'
export var appid = 'wx3a93eb5bf70cbe6f'
export var resourcepath = getresourcepath();
export var isweixin = isWeiXinfn()
export var devicetype = getdevicetype()
export var ismobile = ismobilefn();
export var START_EV = touchstartfn()
export var MOVE_EV = touchmovefn()
export var END_EV = touchendfn();



export function netget(path, data) {
    return new Promise(function (resolve, reject) {
        axios.get(path, {
            params: data
        }).then(function (response) {
            // 按需求来，这里我需要的是response.data，所以返回response.data，一般直接返回response
            resolve(response.data);
        }).catch(function (error) {
            reject(error);
        });
    });
}
export function netpost(path, data) {
    if (!data) {
        alert('没有传递数据 可以随便传个json对象{xx:1}');
        return false;
    }
    return new Promise(function (resolve, reject) {
        axios.post(path, data).then(function (response) {
            resolve(response.data);
        }).catch(function (error) {
            reject(error);
        });
    });
}



export function initAnimFn() {
    var p1_areaanimxiayutag = 0;
    var p1_areaanimxiayutimer;

    function p1_areaanimxiayu() {
        p1_areaanimxiayutimer = setTimeout(function () {
            var animitemw = $(".p1_1areaanim_areaanimitem1").width();
            var animitemh = $(".p1_1areaanim_areaanimitem1").height();
            p1_areaanimxiayutag++;
            var ywidth = $('.p1_areaanim').width();
            var tops = $('.p1_areaanim').offset().top;
            var yheight = $('.p1_areaanim').height();
            var leftsuiji = RandomNumBoth(30, ywidth - 30);
            var suijixue = RandomNumBoth(3, 4);
            var yudi = '<img  id="p1_areaanimxiayutag' + p1_areaanimxiayutag + '" style="left:' + leftsuiji + 'px; " p1_areaanimxiayutag="' + p1_areaanimxiayutag + '"  class="p1_areaanim_areaanimitem2 xiayu1" src=' + resourcepath + '/images/1/p1_areaanim_areaanimitem' + suijixue + '.png />';
            $(".p1_areaanim").append(yudi);
            p1_areaanimxiayu();
            var p1_areaanim_areaanimitem2length = $('.p1_areaanim_areaanimitem2').length;
            if (p1_areaanim_areaanimitem2length >= 10) {
                $(".p1_areaanim_areaanimitem2:lt(3)").remove();
            }
        }, 1000)
    }
    p1_areaanimxiayu();
}












var app;
var stagewidth;
var stageheight;
var i;
var score;
var speed;
var xialuospeed;
var longzhou;
var pengzhuangdian;
var isstoppengzhuangjiance;
var renwuqiehuantimer;
var stoprewuqiehuan;
var sslist;
var biandaojutimer;
var ii;
var diaocount;
var text;
var tm;
var tmleftd;
var tmrightd;
var zuocedaojux;
var zuocedaojux1;
var zuocedaojuy;
var zhongdiany;
var youcedaojux;
var youcedaojux1;
var youcedaojuy;
var wuti5spic;
var wuti4spic;
var iszantinggame;
var leftbiandaojudiaotimer;
var rightbiandaojudiaotimer;
var yangmaodiaotimer;














function vueTouch(el, binding, type) {
    var _this = this;
    this.obj = el;
    this.binding = binding;
    this.touchType = type;
    this.vueTouches = {
        x: 0,
        y: 0
    };
    this.vueMoves = true;
    this.vueLeave = true;
    this.longTouch = true;

    this.vueCallBack = typeof (binding.value) == "object" ? binding.value.fn : binding.value;

    this.obj.addEventListener("touchstart", function (e) {
        _this.start(e);
    }, false);

    this.obj.addEventListener("touchmove", function (e) {
        _this.move(e);
    }, false);

    this.obj.addEventListener("touchend", function (e) {
        _this.end(e);
    }, false);
};
vueTouch.prototype = {
    start(e) {
        this.vueMoves = true;
        this.vueLeave = true;
        this.longTouch = true;
        this.vueTouches = {
            x: e.changedTouches[0].pageX,
            y: e.changedTouches[0].pageY
        };
        this.time = setTimeout(function () {
            if (this.vueLeave && this.vueMoves) {
                this.touchType == "longtap" && this.vueCallBack(this.binding.value, e);
                this.longTouch = false;
            };
        }.bind(this), 1000);
    },
    end(e) {
        var disX = e.changedTouches[0].pageX - this.vueTouches.x;
        var disY = e.changedTouches[0].pageY - this.vueTouches.y;
        clearTimeout(this.time);
        if (Math.abs(disX) > 10 || Math.abs(disY) > 100) {
            this.touchType == "swipe" && this.vueCallBack(this.binding.value, e);
            if (Math.abs(disX) > Math.abs(disY)) {
                if (disX > 10) {
                    this.touchType == "swiperight" && this.vueCallBack(this.binding.value, e);
                };
                if (disX < -10) {
                    this.touchType == "swipeleft" && this.vueCallBack(this.binding.value, e);
                };
            } else {
                if (disY > 10) {
                    this.touchType == "swipedown" && this.vueCallBack(this.binding.value, e);
                };
                if (disY < -10) {
                    this.touchType == "swipeup" && this.vueCallBack(this.binding.value, e);
                };
            };
        } else {
            if (this.longTouch && this.vueMoves) {
                this.touchType == "tap" && this.vueCallBack(this.binding.value, e);
                this.vueLeave = false
            };
        };
    },
    move(e) {
        this.vueMoves = false;
    }
};
import Vue from 'vue'

Vue.directive("tap", {
    bind: function (el, binding) {
        new vueTouch(el, binding, "tap");
    }
});
Vue.directive("swipe", {
    bind: function (el, binding) {
        new vueTouch(el, binding, "swipe");
    }
});
Vue.directive("swipeleft", {
    bind: function (el, binding) {
        new vueTouch(el, binding, "swipeleft");
    }
});
Vue.directive("swiperight", {
    bind: function (el, binding) {
        new vueTouch(el, binding, "swiperight");
    }
});
Vue.directive("swipedown", {
    bind: function (el, binding) {
        new vueTouch(el, binding, "swipedown");
    }
});
Vue.directive("swipeup", {
    bind: function (el, binding) {
        new vueTouch(el, binding, "swipeup");
    }
});
Vue.directive("longtap", {
    bind: function (el, binding) {
        new vueTouch(el, binding, "longtap");
    }
});

// 如果cookie获取不到 说明还没授权登录 然后router会去授权登录 
// var session_key=getCookie('SESSIONKEY_' + kongzhiqi.toUpperCase());
// var openid=getCookie('OAUTH_' + kongzhiqi.toUpperCase());
var session_key = 0
var openid = 0

export function recordzjlistajax(parentobj, action, successfn) {
    var phontypej = parentobj.find('.phonetype');
    var biaodanziduanj = parentobj.find('.biaodanziduan');
    var eachcount = 0;
    if (phontypej.length > 0) {
        //提交姓名和手机号信息
        var phontypejlen = phontypej.val().length;
        if (phontypejlen == 0) {
            tanc('手机号不能为空');
            return false;
        }
        if (phontypejlen > 0) {
            if (!/^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i.test(phontypej.val())) {
                tanc('手机号码不对');
                return false;
            }
        }
    }
    var ziduanlist = new Object();
    biaodanziduanj.each(function () {
        eachcount++
        /*如果有requiretip属性就要判断*/
        var requiretip = $(this).attr('requiretip');
        if (!iskong(requiretip)) {
            var val = $(this).val();
            if (iskong(val)) {
                tanc(requiretip);
                return false;
            }
        }
        store.commit("isshowjiazaiset", 1);
        var ziduanname = $(this).attr('ziduanname');
        var iskongimg = iskong($(this).attr('src'));
        if (iskongimg) {
            var ziduanval = $(this).val();
        } else {
            var ziduanval = $(this).attr('src');
        }
        ziduanlist[ziduanname] = ziduanval;


        if (eachcount >= biaodanziduanj.length) {
            if (phontypej.length > 0) {
                var phontypejlen = phontypej.val().length;
                if (phontypejlen == 0) {
                    tanc('请填写您的联系方式');
                    return false;
                }
                if (phontypejlen > 0) {
                    if (!/^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i.test(phontypej.val())) {
                        tanc('手机号码不对');
                        return false;
                    }
                }
            }
            store.commit("isshowjiazaiset", 1);

            netpost('/' + kongzhiqi + '/' + action, ziduanlist).then((data) => successfn(data))

        }
    });
}

var openDalay = false;
// v-tous="{func:testclick,data:['b']}"      let play_id = el.getAttribute("play_id")
Vue.directive("tous", {
    bind: function (el, binding) {

        if (ismobile) {

            el.addEventListener('touchstart', (event) => {
                if (openDalay) return;
                openDalay = !openDalay
                setTimeout(() => {
                    openDalay = !openDalay
                }, 200)
                if (Array.isArray(binding.value.data)) {
                    binding.value.func(...binding.value.data)
                } else {

                    binding.value(el);
                }

            });
        } else {
            el.addEventListener('click', (event) => {
                if (openDalay) return;
                openDalay = !openDalay
                setTimeout(() => {
                    openDalay = !openDalay
                }, 200)
                if (Array.isArray(binding.value.data)) {
                    binding.value.func(...binding.value.data)
                } else {

                    binding.value(el);
                }

            });
        }

    }
})
Vue.directive("tous1", {
    bind: function (el, binding) {


        el.addEventListener('click', (event) => {
            if (openDalay) return;
            openDalay = !openDalay
            setTimeout(() => {
                openDalay = !openDalay
            }, 200)
            if (Array.isArray(binding.value.data)) {
                binding.value.func(...binding.value.data)
            } else {

                binding.value(el);
            }

        });

    }
});



var curY = 0;
var moveY = 0;
var leijiY = 0;
var isCanDrag = 1;
export function xiaanim() {

    var bodywidth = parseInt($("body").width());
    var bodyheight = parseInt($("body").height());
    var canvasheight = (750 * bodyheight) / bodywidth;
    var app = new PIXI.Application({
        width: 750,
        height: canvasheight,
        transparent: true,
    });
    $(".xialaanim").html(app.view);

    var huayuanquyu = new PIXI.Graphics();
    huayuanquyu.beginFill(0xff001f, 1);
    huayuanquyu.drawRoundedRect(0, 0, app.screen.width, app.screen.height, 0);
    huayuanquyu.endFill();
    // huayuanquyu.alpha = 0;
    huayuanquyu.name = "huayuanquyu";
    app.stage.addChild(huayuanquyu);
    huayuanquyu.interactive = true;
    huayuanquyu
        .on("pointerdown", onDragStart)
        .on("pointerup", onDragEnd)
        .on("pointermove", onDragMove);
    function onDragStart(event) {
        const initPosition = event.data.getLocalPosition(this.parent);
        curY = initPosition.y;
        isCanDrag = 1;

    }

    function onDragEnd(event) {
        isCanDrag = 0;
        const newPosition = event.data.getLocalPosition(this.parent);
        leijiY += Math.abs(newPosition.y - curY);
        console.log(leijiY);

    }

    function onDragMove(event) {
        if (isCanDrag == 1) {
            const newPosition = event.data.getLocalPosition(this.parent);
            moveY = Math.abs(newPosition.y - curY) + leijiY;
            console.log(moveY);
            // allcontainer.y = moveY
            // chufaactfn(moveY);
        }

    }
}

var jieshu = 0;
function chufaactfn(value) {
    absval = Math.abs(parseInt(value));
    console.log('absval:' + absval);
    // 自定义动画
    if (absval <= maxval && absval >= minval) {
        var alldis = maxval - minval;
        var alreadywalkdis = absval - minval;
        var walkpercent = alreadywalkdis / alldis;
        console.log('walkpercent' + walkpercent);
        tl3.progress(walkpercent);
        // armatureDisplay.x = 500
        // armatureDisplay.scale.x = 0.6;
        // armatureDisplay.scale.y = 0.6;
    } else if (absval > maxval) {
        var alreadywalkdis = absval - maxval;
        p2_lieche_wrap1.y = liecheiniy + alreadywalkdis;
    }
    if (absval >= 28792) {
        if (jieshu == 1) {
            return false;
        }
        jieshu = 1;
        setTimeout(function () {
            app.ticker.stop();
            // pagegundong1($('.p3'), true);
            /*用异步 防止显示图片堵塞 */
            console.log("一共多少帧:" + base64imglist.length);

            for (var k in base64imglist) {
                console.log(k);
                $.ajax({
                    type: "post",
                    url: "/home/zhongliangchangtu2/recordbase64img",
                    data: {
                        "base64img": base64imglist[k],
                    },
                    async: false,
                    dataType: "json",
                    success: function (data) {
                        $('.jiazaicontainer').css('display', 'none');
                        if (data.code == 100) {

                        } else {
                            tanc(data.msg);
                        }
                    },
                    error: function () {
                        $('.jiazaicontainer').css('display', 'none');
                        tanc('访问人数过多,请稍后再试哦~');
                    }
                });
            }
            alert('提交完成');
        }, 1000)
    }
    var appAllChildren = allcontainer.children
    var acNum = appAllChildren.length
    for (var i = 0; i < acNum; i++) {
        var appAllChildren1 = appAllChildren[i].children;
        var acNum1 = appAllChildren1.length;
        for (var k = 0; k < acNum1; k++) {
            if (Math.abs(appAllChildren1[k].getBounds().y) < 800) {
                var chufaanim = appAllChildren1[k].chufaanim;
                if (appAllChildren1[k].name == "p1a_wrap1_wz4") {
                    // console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
                    // console.log();
                    // console.log(value);
                    // console.log(appAllChildren1[k].y);
                    // console.log('ffffffffffffffffffffffffffffffffffff');
                }
                if (!iskong(chufaanim)) {
                    // console.log('触发元素');
                    // console.log(appAllChildren1[k]);
                    // console.log(chufaanim);
                    donghuachuli(appAllChildren1[k], chufaanim);
                }
            }
        }
    }
}
export function initsj() {
    store.commit('yujiazaiset', 1);
    store.commit('jinduset', 0);
}


// WEBPACK FOOTER //
// ./src/commonjs/commonfn.js